<template>
  <svg
    width="12"
    height="18"
    viewBox="0 0 12 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.31533 1L2 10.7642L5.74288 10.3947L4.10553 17L10 8.09593L6.30444 8.43095L8.31533 1Z"
      fill="#FABB05"
      stroke="#FABB05"
      stroke-width="1.2"
    />
  </svg>
</template>
